import { render } from "./PolicyRules.vue?vue&type=template&id=a9cfc56e"
import script from "./PolicyRules.vue?vue&type=script&lang=js"
export * from "./PolicyRules.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__